import React, { forwardRef } from 'react';
import { Root } from '@radix-ui/react-radio-group';
import { Flex } from '..';
export const RadioGroup = forwardRef(({ className, children, direction = 'horizontal', ...props }, forwardedRef) => (React.createElement(Root, { ref: forwardedRef, className: className, asChild: true, ...props },
    React.createElement(Flex, { direction: direction === 'horizontal' ? 'row' : 'column', columnGap: 16, rowGap: 16, inline: true }, children))));
RadioGroup.displayName = 'RadioGroup';
